module.exports = __webpack_public_path__ + "img/CostaRica.9fe6434a.png";